import { ChangeEvent, ChangeEventHandler, forwardRef, memo, TextareaHTMLAttributes, useCallback } from "react";
import { InputContainer, InputContainerProps } from "../InputContainer";

type BaseTextAreaProps = InputContainerProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;

export type TextAreaProps = Omit<BaseTextAreaProps, "inputComponent" | "onChange" | "value"> & {
  onChange?: (value: string | null, e?: ChangeEvent<HTMLTextAreaElement> | null) => void,
  value?: string | null
}

export const TextArea = memo(forwardRef<HTMLTextAreaElement, TextAreaProps>((
  {
    onChange,
    value,
    ...props
  },
  ref,
) => {
  const wrappedOnChange = useCallback<ChangeEventHandler<HTMLTextAreaElement>>(
    (e) => onChange?.(e?.target?.value || null, e),
    [ onChange ],
  );

  return (
    <InputContainer
      hideErrorIcon
      {...props}
      value={value || ""}
      ref={ref}
      inputComponent={"textarea"}
      onChange={wrappedOnChange}
    />
  );
}));